import type { PropsWithChildren } from 'react'

export const ProvisionerSection = ({ children }: PropsWithChildren) => (
  <div className="border-fv-gray-400 my-2 border p-4">{children}</div>
)

export const ProvisionerSectionHeader = ({ children }: PropsWithChildren) => (
  <h4 className="mt-4 text-xl">{children}</h4>
)
